import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: user.name || "", phone: user.phone || "", company: user.company || "" });
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/auth/profile", form);
      setUser(data);
      toast.success("Profilo aggiornato");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const field = (k, label, type = "text") => (
    <div>
      <label className="label">{label}</label>
      <input className="field" type={type} value={form[k]} data-testid={`profile-${k}-input`} onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
    </div>
  );
  return (
    <div className="max-w-xl">
      <div className="eyebrow mb-2">Account</div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase mb-8">Profilo</h1>
      <form onSubmit={save} className="surface p-6 space-y-4">
        <div className="text-sm text-slate-400">Email: <span className="text-white" data-testid="profile-email">{user.email}</span></div>
        {field("name", "Nome e cognome")}
        {field("company", "Officina / Azienda")}
        {field("phone", "Cellulare WhatsApp", "tel")}
        <p className="text-xs text-slate-500">Il numero viene usato dal tecnico per avviare la sessione live su WhatsApp.</p>
        <button className="btn-red px-6 py-3 flex items-center gap-2" disabled={busy} data-testid="profile-save-button">
          {busy && <Loader2 size={16} className="animate-spin" />} Salva
        </button>
      </form>
    </div>
  );
}
